import { ReleaseHighlight } from '../interfaces/release-highlight.interface';

export const RELEASE_HIGHLIGHTS_CONFIG: { releaseId: string; highlights: ReleaseHighlight[] } = {
    releaseId: '26.3',
    highlights: [
        {
            imageUrl: 'assets/images/release-highlights/feature1.png',
            htmlContent: 'aumico_release_slide_1_html',
        },
        {
            imageUrl: 'assets/images/release-highlights/feature2.png',
            htmlContent: 'aumico_release_slide_2_html',
        },
        {
            imageUrl: 'assets/images/release-highlights/feature3.png',
            htmlContent: 'aumico_release_slide_3_html',
        },
        {
            imageUrl: 'assets/images/release-highlights/feature4.png',
            htmlContent: 'aumico_release_slide_4_html',
        }
    ],
};
